import StatisticsPanel from "./StatisticsPanel";
import TablePanel from "./TablePanel";
import PanelGroup from "./PanelGroup";

export default {
  Statistics: StatisticsPanel,
  Table: TablePanel,
  Group: PanelGroup,
};
